import { Day } from '@/models';
import { DailyWorkloadResponse, SchoolTransportService } from '@/transports';
import { FeatureFlagService } from '../../services';
import { BaseLoadableValue, LoadableValue } from './Loadable';

export type CourseSectionDailyWorkloadLoadable = LoadableValue<DailyWorkloadResponse>;

export class AppCourseSectionDailyWorkloadLoadable extends BaseLoadableValue<DailyWorkloadResponse> {
  constructor(
    private readonly _courseSectionId: string,
    private readonly _schoolId: string,
    private readonly _date: Day,
    private readonly _schoolTransport: SchoolTransportService,
    private readonly _featureFlag: FeatureFlagService
  ) {
    super();
  }

  protected async loadData(): Promise<DailyWorkloadResponse> {
    if (!this._featureFlag.isEnabled('workload-manager')) {
      return { dailyWorkloads: [], courseSections: [] };
    }

    return await this._schoolTransport.getDailyWorkload(
      this._schoolId,
      [this._courseSectionId],
      this._date,
      this._date
    );
  }
}
